var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElasticCache(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.064209 16.2191L9.99999 24L19.9359 16.2191L9.99968 14.9838L0.064209 16.2191Z",
    fill: "#94ACF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 7.78055L9.93555 9.01594L20 7.78094L10 0Z",
    fill: "#132762"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0L0 4.96805V7.78094L10 4.80008V0Z",
    fill: "#3260E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0319L10 24V19.1998L0 16.2194V19.0319Z",
    fill: "#3260E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 15.6292L5.66675 14.9944V9.05402L10.0001 8.42902L10.1024 8.62683L10.0916 15.4314L10.0001 15.6292Z",
    fill: "#3260E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0V4.80008L20 7.78094V4.96805L10 0Z",
    fill: "#6484E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.1998V24L20 19.0319V16.2194L10 19.1998Z",
    fill: "#6484E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.6292L14.3334 14.9944V9.05402L10 8.42902V15.6292Z",
    fill: "#6484E0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticCache);
export default __webpack_public_path__ + "static/media/elastic-cache.afd665f7.svg";
export { ForwardRef as ReactComponent };